import { MutationTree } from 'vuex'
import { mutationType } from './mutation-types'
import SosState, {SosList} from './states'
import _ from 'lodash'
import axios from 'axios'

const completePathFn = process.env.VUE_APP_BASEURL
const mutations: MutationTree<SosState> = {
  [mutationType.GET_LISTS](
    state: SosState,
    data: SosList,
  ): void {
    state.list = data
  },
}

export default mutations
